export class TenantCloudDTO {
    PK;
    Sk;
    id;
    createdAt;
    updatedAt;
    tenants;
    questionnaires;
    name;
    description;
    type;

    constructor(cloud) {
        if (cloud.id != null) {
            this.PK = cloud.PK;
            this.SK = cloud.SK;
        }
        else {
            this.PK = `TENANTCLOUDS`;
            this.SK = "TENANTCLOUD#";
        }
        this.id = cloud.id;
        this.type = "TENANTCLOUD";
        this.name = cloud.name;
        this.description = cloud.description;
        this.tenants = cloud.tenants;
        this.questionnaires = cloud.questionnaires;
    }
}